
import { Component, inject, input, OnInit, output, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ClientController, ClientEntity } from '@domain';
import { debounceTime } from 'rxjs';
import { AddressFormatPipe } from '../../pipes/address-format.pipe';
import { RaEmptyComponent } from '../ra-empty/ra-empty.component';
import { RaFilletComponent } from '../ra-fillet/ra-fillet.component';
import { RaInputComponent } from '../ra-input/ra-input.component';
import { RaLoadingComponent } from '../ra-loading/ra-loading.component';
import { RaModalComponent } from '../ra-modal/ra-modal.component';

@Component({
    selector: 'ra-modal-list-clients',
    templateUrl: 'ra-modal-list-clients.component.html',
    styleUrl: 'ra-modal-list-clients.component.scss',
    imports: [
    ReactiveFormsModule,
    RaModalComponent,
    RaLoadingComponent,
    RaEmptyComponent,
    AddressFormatPipe,
    RaInputComponent,
    RaFilletComponent,
    TranslatePipe,
],
})
export class RaModalListClientsComponent implements OnInit {
    public message = input<string>();
    public close = output();
    public selectClient = output<ClientEntity>();
    public loading = signal(true);
    public clients = signal<ClientEntity[]>([]);
    public clientsFiltered = signal<ClientEntity[]>([]);
    public searchControl = new FormControl('');

    // * [Injects]
    private _clientController = inject(ClientController);

    ngOnInit(): void {
        this._getClients();
        this._listenSearchControl();
    }

    private _getClients(): void {
        this.loading.set(true);
        this._clientController.getAll().subscribe({
            next: clients => {
                this.clients.set(clients);
                this.clientsFiltered.set(clients);
                this.loading.set(false);
            },
            error: () => this.loading.set(false),
        });
    }

    private _filterClients(): void {
        const searchValue = this.searchControl.value?.toLowerCase().trim() || '';

        if (!searchValue) {
            this.clientsFiltered.set(this.clients());
            return;
        }

        this.clientsFiltered.set(
            this.clients().filter(client => client.name?.toLowerCase().includes(searchValue))
        );
    }

    private _listenSearchControl(): void {
        this.searchControl.valueChanges
            .pipe(debounceTime(600))
            .subscribe(() => this._filterClients());
    }
}
